import React from "react";
import RatesDashboardRoomTypeCell from "./RatesDashboardRoomTypeCell";
import RatesDashboardRateCell from "./RatesDashboardRateCell";

class RatesDashboardSidebar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    var room_types_and_rates = [];
    var room_types_count = 0;
    var rates_count = 0;

    for (var i = 0, ilen = this.props.room_types.length; i < ilen; i++) {
      var room_type = this.props.room_types[i];
      room_types_and_rates.push(
        <RatesDashboardRoomTypeCell
          key={"room_type_" + room_type.id}
          room_type={room_type}
          top={this.calculateTop(room_types_count, rates_count)}
          onExpandCollapseRoomType={self.props.onExpandCollapseRoomType}
        />
      );
      room_types_count++;

      if (typeof room_type.collapsed === "undefined" || room_type.collapsed) {
        // do not display rates
      } else {
        for (var j = 0, jlen = room_type.rates.length; j < jlen; j++) {
          var rate = room_type.rates[j];
          room_types_and_rates.push(
            <RatesDashboardRateCell
              key={"room_type_" + room_type.id + "_rate_" + rate.id}
              rate={rate}
              top={this.calculateTop(room_types_count, rates_count)}
            />
          );
          rates_count++;
        }
      }
    }

    return <div className="RatesDashboardSidebar">{room_types_and_rates}</div>;
  }

  calculateTop(room_types_count, rates_count) {
    return room_types_count * 80 + rates_count * 60;
  }
}

export default RatesDashboardSidebar;
